import { ref } from 'vue'

export interface Toast {
  id: number
  message: string
  timestamp: number
  type: 'success' | 'error'
}

// 전역 상태로 관리하기 위한 refs
const toasts = ref<Toast[]>([])
let nextId = 0

export function useToast() {
  const showToast = (message: string, type: 'success' | 'error' = 'success') => {

    const toast: Toast = {
      id: nextId++,
      message,
      timestamp: Date.now(),
      type
    }
    toasts.value.push(toast)

    setTimeout(() => {
      removeToast(toast.id)
    }, 3000)
  }

  const removeToast = (id: number) => {
    const index = toasts.value.findIndex(toast => toast.id === id)
    if (index > -1) {
      toasts.value.splice(index, 1)
    }
  }

  return {
    toasts,
    showToast,
    removeToast
  }
}